import { TableViewerComponent } from './components/Table';

import powerIconSwitch from '../../../assets/switch-button-power-icon.png';

import carIcon from '../../../assets/car-icon.png';
import autonomyIcon from '../../../assets/autonomy-icon.png';

import plateIcon from '../../../assets/plate-icon.png';
import socketIcon from '../../../assets/socket-icon.png';

export const RechargePriorityPage = ({ data }: any) => {
  return (
    <TableViewerComponent
      data={data}
      extraColumn={[
        {
          name: 'autonomy',
          label: 'Site mais próximo',
          align: 'left',
          icon: socketIcon,
          render: (dataColumn: any) => {
            return (
              dataColumn.uvId && (
                <div
                  className=''
                  style={{
                    background: '#e0ece9',

                    lineHeight: '35px',
                    padding: '0px 10px',
                    width: '100%',
                  }}
                >
                  <div
                    className='vp-power-kW'
                    style={{
                      fontSize: 12,
                      lineHeight: 1.2,
                      height: 35,
                      display: 'flex',
                      alignItems: 'center',
                      textAlign: 'left',
                    }}
                  >
                    Site mais próximo
                  </div>
                </div>
              )
            );
          },
        },
        {
          name: 'autonomy',
          label: 'Site mais próximo',
          colspan: 2,
          align: 'center',
          icon: socketIcon,
          render: (dataColumn: any) => {
            return (
              dataColumn.uvId && (
                <div
                  style={{
                    padding: '0x 10px',
                    background: '#F9FAF8',
                    paddingLeft: 10,
                    width: '100%',
                  }}
                >
                  <div
                    className='vp-power-kW'
                    style={{
                      fontSize: 12,
                      lineHeight: 1.2,
                      height: 35,
                      display: 'flex',
                      alignItems: 'center',
                      textAlign: 'left',
                    }}
                  >
                    {dataColumn.csName ? dataColumn.csName : '-'}
                  </div>
                </div>
              )
            );
          },
        },
      ]}
      columns={[
        {
          name: 'vehicle',
          label: 'Veículo',
          align: 'left',
          icon: carIcon,
          render: (dataColumn: any) => {
            return (
              <div className='vp-charger-info'>
                <span className='vp-charger-name'>{dataColumn.uvName}</span>
                <span className='vp-cp-code'>
                  Bateria:{' '}
                  {dataColumn.uvTelemetrySoc === null
                    ? '-'
                    : `${dataColumn?.uvTelemetrySoc?.toFixed(0)}%`}
                  {dataColumn.isCharging ? (
                    <img
                      src={powerIconSwitch}
                      alt={`${powerIconSwitch}`}
                      className='cs-table-icon'
                    />
                  ) : (
                    ''
                  )}
                </span>
              </div>
            );
          },
        },
        {
          name: 'autonomy',
          label: 'Autonomia',
          align: 'center',
          icon: autonomyIcon,
          render: (dataColumn: any) => {
            return (
              dataColumn.uvId && (
                <div className='vp-power-info'>
                  <span className='vp-power-kWh'>
                    {dataColumn.uvAutonomyKm} Km
                  </span>
                  <span className='vp-power-kW'>
                    {dataColumn.uvTelemetryBatteryKwh
                      ? dataColumn.uvTelemetryBatteryKwh
                      : '-'}{' '}
                    kWh
                  </span>
                </div>
              )
            );
          },
        },
        {
          name: 'plate',
          label: 'Placa',
          align: 'center',
          icon: plateIcon,
          render: (dataColumn: any) => {
            return (
              <div className='vp-charger-status-container'>
                <div
                  className='vp-chager-status-wrapper'
                  style={{
                    backgroundColor:
                      dataColumn.uvTelemetrySoc < 45
                        ? '#EF6D44'
                        : dataColumn.uvTelemetrySoc >= 45 &&
                          dataColumn.uvTelemetrySoc < 65
                        ? '#FDE047'
                        : '#93E22E',
                    color:
                      dataColumn.uvTelemetrySoc < 45
                        ? '#FFFFFF'
                        : dataColumn.uvTelemetrySoc >= 45 &&
                          dataColumn.uvTelemetrySoc < 65
                        ? '#713F12'
                        : '#196912',
                  }}
                >
                  <span>{dataColumn.uvLicencePlate}</span>
                </div>
              </div>
            );
          },
        },
        // {
        //   name: 'autonomy',
        //   label: 'Site mais próximo',
        //   align: 'center',
        //   icon: socketIcon,
        //   render: (dataColumn: any) => {
        //     return (
        //       dataColumn.uvId && (
        //         <div className='vp-power-info' style={{ lineHeight: '39px' }}>
        //           <span className='vp-power-kW'>
        //             {dataColumn.csName ? dataColumn.csName : '-'}
        //           </span>
        //         </div>
        //       )
        //     );
        //   },
        // },
      ]}
    />
  );
};
